import resetDataLayer from './reset-data-layer';
const pushToDataLayer = (dataLayer, isPageView) => {
  if (dataLayer && window.dataLayer) {
    if (isPageView) resetDataLayer();
    window.dataLayer.push(dataLayer);
  }
};
export default pushToDataLayer;
//# sourceMappingURL=push-to-data-layer.js.map